import "./styles/main.scss";
import "./scripts/app.js";

console.groupCollapsed("Site Credits");
console.log("Development by Madison Hardt https://www.softwave.nyc/");
console.groupEnd();
